<template>
  <CustomModal v-if="open" @close="$emit('close')" class="invest-modal">
    <template v-slot:body>
      <LeftGradientBlockLayout>
        <LeftGradientBlockLayoutHead>
          <template slot="title">{{ $t('modalTitle') }}</template>
          <template slot="form-menu">
            <RadioTags v-model="deal_type"
                       :options="deal_type_list"
                       name="deal-type"/>
          </template>
        </LeftGradientBlockLayoutHead>
        <ManualDealsForm :deal_type="deal_type" @success="$emit('close')"/>
      </LeftGradientBlockLayout>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import LeftGradientBlockLayout from "@/components/layouts/cabinet/LeftGradientBlockLayout/LeftGradientBlockLayout";
import LeftGradientBlockLayoutHead
  from "@/components/layouts/cabinet/LeftGradientBlockLayout/LeftGradientBlockLayoutHead";
import ManualDealsForm from "@/components/cabinet/Investments/modals/ManualDealsModal/ManualDealsForm";
import RadioTags from "@/components/UI/RadioTags";
import {mapGetters} from "vuex";
import {dealTypes} from "@/utilities/invest_deal_types";

export default {
  name: "ManualExpensesModal",
  components: {
    RadioTags,
    ManualDealsForm,
    LeftGradientBlockLayoutHead,
    LeftGradientBlockLayout,
    CustomModal
  },
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      deal_type: null,
      submitted: false,
    }
  },
  computed: {
    deal_type_list() {
      return [
        {value: dealTypes.TYPE_EXPENSE_COMMISSION, text: this.$t('commission'), color: 'red'},
        {value: dealTypes.TYPE_EXPENSE_TAX, text: this.$t('tax'), color: 'red'}
      ]
    }
  },
  watch:{
    open(val) {
      if (val){
        this.deal_type = dealTypes.TYPE_EXPENSE_COMMISSION;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        modalTitle: 'Expense',
        commission: 'Commission',
        tax: 'Tax',
      },
      ru: {
        modalTitle: 'Расход',
        commission: 'Комиссия',
        tax: 'Налог',
      }
    }
  }
}
</script>